import React, { useEffect, useState } from "react";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { propertyDetails, setHomeNavigate } from "../../reducer/selfCheckinSlice";
import { InnLoader } from "../innLoader";


function ThankYou() {

  const propertyObj = useSelector(propertyDetails);
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const wait = timeOut => {
    return new Promise(resolve => setTimeout(resolve, timeOut));
}
useEffect(() => {
  setIsActive(true);
  if (propertyObj === undefined) {
    navigate("/Unauthorised")
}
  wait(1000).then(() => setIsActive(false))
},[])
  return (
    <div>
      <InnLoader className={isActive ? "active" : null}></InnLoader>
      <div>
        <div class="guest-opt-grn-bg reg-thanks-icon"></div>
        <div class="reg-thanks">
          <h2>Thanks</h2>
        </div>
        <div class="reg-thanks-btm">
          <div class="reg-thanks-btm-icon">
            <img src={buldingIcon} />
          </div>
          <h3>{propertyObj?.Name} - {propertyObj?.CityName}</h3>
          {/* <Link to="/HomeInfo"> */}
          <button class="drk-blue-btn"
            onClick={() => {
              navigate("/HomeInfo")
              dispatch(setHomeNavigate("ThankYouPage"));
            }}
          > Hotel Information </button>


          {/* </Link> */}
        </div>
      </div>
      <div class="overlay">
        <div class="overlay-background"></div>
        {/* <div class="overlay-content"><span class="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
      </div>
      <div class="hidden">
        <div class="loader-overlay"></div>
      </div>
    </div>
  );
}

export default ThankYou;
